module.exports = __webpack_public_path__ + "static/media/logo_white.4a883766.svg";